export default {
	menus: [
		{
			title: '系统管理',
			key: 'clue',
			icon: 'icon-head',
			children: [
				{
					title: '咨询管理',
					key: 'CMember'
				},
				{
					title: '支付记录',
					key: 'CPay'
				},
				{
					title: '套餐管理',
					key: 'CGroup'
				}
			]
		},
	]
}
